const routes = [
  {
    name: 'facturacion',
    path: '/facturacion',
    redirect: '/facturacion/facturas'
  },
  {
    name: 'facturacion.facturas',
    path: '/facturacion/facturas',
    component: () => import('../pages/FacturaManagementPage'),
    meta: {
      requiresAuth: true
      // TODO: Agregar permission: 'FACTURACION_FACTURA_SHOW'
    }
  },
  {
    name: 'facturacion.configuracion',
    path: '/facturacion/configuracion',
    component: () => import('../pages/ConfiguracionAfipPage'),
    meta: {
      requiresAuth: true
      // TODO: Agregar permission: 'FACTURACION_CONFIG_AFIP'
    }
  }
]

export default routes
